"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEYS = void 0;
var KEYS = {
  UP: 38,
  DOWN: 40,
  ENTER: 13,
  ESC: 27,
  PLUS: 43,
  A: 65,
  Z: 90,
  SPACE: 32,
  TAB: 9
};
exports.KEYS = KEYS;


//////////////////
// WEBPACK FOOTER
// ./~/react-intl-tel-input/dist/components/constants.js
// module id = 2156
// module chunks = 2